export default "__VITE_ASSET__81aed669__"